import { gql } from "@apollo/client"

const DELETE_GROUP_LESSON_NOTE = gql`
  mutation deleteGroupLessonNote($input: DeleteGroupLessonNoteInput!) {
    deleteGroupLessonNote(input: $input) 
  }
`

export { DELETE_GROUP_LESSON_NOTE }
